"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _color = require("../../utils/color.utils");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _animations = require("../../styles/animations");
var _templateObject, _templateObject2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DayButton = function DayButton(_ref) {
  var dayzedDateObject = _ref.dayzedDateObject,
    dayzedDateProps = _ref.dayzedDateProps,
    backgroundColor = _ref.backgroundColor,
    baseTextColor = _ref.baseTextColor,
    selectedTextColor = _ref.selectedTextColor,
    isDateSelectable = _ref.isDateSelectable,
    isDisabled = _ref.isDisabled,
    className = _ref.className,
    isLoading = _ref.isLoading;
  if (!dayzedDateObject) {
    return /*#__PURE__*/_react["default"].createElement(Container, {
      isDisabled: true,
      onClick: null,
      testId: "day-button-skeleton"
    });
  }
  var date = dayzedDateObject.date,
    today = dayzedDateObject.today,
    selected = dayzedDateObject.selected,
    selectable = dayzedDateObject.selectable;
  var canSelectDate = isDateSelectable(date) && selectable;
  var _isDisabled = isDisabled || !canSelectDate;

  // calc colors
  var dayBackgroundColor = _colors["default"].transparent;
  var dayTextColor = baseTextColor;
  if (isLoading) {
    dayBackgroundColor = _colors["default"].transparent;
  } else if (!canSelectDate) {
    dayTextColor = (0, _color.applyOpacity)(baseTextColor, 30);
  } else if (selected) {
    dayBackgroundColor = backgroundColor;
    dayTextColor = selectedTextColor;
  } else if (today) {
    dayBackgroundColor = (0, _color.applyOpacity)(backgroundColor, 10);
  }
  var hoverBackgroundColor = canSelectDate ? (0, _color.applyOpacity)(backgroundColor, 20) : '';
  var hoverTextColor = canSelectDate ? backgroundColor : '';

  // end calc colors

  var testId = "DayButton-".concat(new Date(date).toDateString());
  return /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    className: className,
    isDisabled: _isDisabled,
    $isLoading: isLoading,
    testId: testId,
    $backgroundColor: dayBackgroundColor,
    $selected: selected,
    $hoverBackgroundColor: hoverBackgroundColor,
    $hoverTextColor: hoverTextColor
  }, dayzedDateProps), isLoading ? /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], null) : /*#__PURE__*/_react["default"].createElement(DayText, {
    type: "body14",
    textColor: dayTextColor
  }, date.getDate()));
};
var _default = exports["default"] = DayButton; // --- Styles ---
var DayText = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "DayButton__DayText",
  componentId: "sc-1n6az03-0"
})(["color:", ";", ";"], function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor || _colors["default"].black;
}, (0, _animations.transition)('color'));
var Container = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "DayButton__Container",
  componentId: "sc-1n6az03-1"
})(["display:flex;width:36px;height:36px;justify-content:center;align-items:center;border-radius:50%;background-color:", ";", " ", ""], function (_ref3) {
  var $backgroundColor = _ref3.$backgroundColor;
  return $backgroundColor || _colors["default"].transparent;
}, (0, _styledIs.isNot)('$selected', 'isDisabled')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n        &:hover,\n        &:focus-visible {\n            ", " {\n                color: ", ";\n            }\n        }\n    "])), function (props) {
  return (0, _animations.hoverTransition)('background-color', props.$backgroundColor, props.$hoverBackgroundColor);
}, DayText, function (_ref4) {
  var $hoverTextColor = _ref4.$hoverTextColor;
  return $hoverTextColor || 'inherit';
}), (0, _styledIs["default"])('$isLoading')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        span {\n            display: block;\n            border-radius: 50%;\n            width: 100%;\n            height: 100%;\n        }\n    "]))));
//# sourceMappingURL=DayButton.js.map